let mutations = {
  activeTransaction (state, data) {
    
    state.activeTransaction = data
  },
  settledTxnError (state, data) {
    state.settledTxnError.status = data.status
  },
  settledTransactions (state, data) {
    if(data.append){
      state.settledTransactions += data.response
    }
    else{
      state.settledTransactions = data.response
    }
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/transaction/mutations.js